<template>
    <div>
    <b-col xs="12" lg="12">
        <b-row>
            <b-col xs="12" lg="2" class="heading-icon">
                <img :src="model.icon" width="64px" height="64px"/> <h4>{{ $t('webforms') }}</h4>
            </b-col>
            <b-col xs="12" lg="10">
                <p>
                  {{ $t('webformsUsage') }}
                </p>
            </b-col>
        </b-row>
    </b-col>

    <ActivateFooter :integration="model"/>
    </div>
</template>
<style>
.heading-icon {
    text-align: center;
}
</style>
<script>
import ActivateFooter from '../ActivateFooter'
export default {
    components: {
        ActivateFooter
    },
    props: {
        model: {
            Type: Object,
            default: function() {
                return null
            }
        },
        active: {
            type: Boolean,
            default: false
        }
    },

    data: function() {
        return {}
    },

    methods: {}
}
</script>
